import { createRouter, createWebHistory } from 'vue-router'
import PageTableReference from '../views/PageTableReference'
import PageFoodByName from '../views/PageFoodByName'
import PageFoodByCode from '../views/PageFoodByCode'
import PageFoodByCategory from '../views/PageFoodByCategory'
import PageFoodByComponent from '../views/PageFoodByComponent'
import PageComponents from '../views/PageComponents'
import PageFoodList from '../views/PageFoodList'
import PageMain from '../views/PageMain'

const routes = [
  { path: '/', redirect: '/Ita', name: 'root' },
  {
    path: '/:lang',
    name: 'main',
    component: PageMain
  },
  {
    path: '/TableReference',
    name: 'referenceDef',
    redirect: '/TableReference/Ita',
    component: PageTableReference
  },
  {
    path: '/TableReference/:lang',
    name: 'reference',
    component: PageTableReference
  },
  {
    path: '/PageFoodByName/:lang',
    name: 'PageFoodByName',
    component: PageFoodByName
  },
  {
    path: '/PageFoodByCode/:lang',
    name: 'PageFoodByCode',
    component: PageFoodByCode
  },
  {
    path: '/PageFoodByCategory/:lang',
    name: 'PageFoodByCategory',
    component: PageFoodByCategory
  },
  {
    path: '/PageFoodList/:lang',
    name: 'PageFoodList',
    component: PageFoodList
  }
  ,
  {
    path: '/PageFoodByComponent/:lang',
    name: 'PageFoodByComponent',
    component: PageFoodByComponent
  }
  ,
  {
    path: '/PageComponents/:lang',
    name: 'PageComponents',
    component: PageComponents
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
